module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewSalaryModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printOfferLetter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printSalaryModal"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.empInfo) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": this.$store.state.imageBaseUrl + 'logo/' + _vm.$store.state.settingRecord.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('center', [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$store.state.settingRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.$store.state.settingRecord.address) + ", " + _vm._s(_vm.$store.state.settingRecord.city) + ", " + _vm._s(_vm.$store.state.settingRecord.state) + " - " + _vm._s(_vm.$store.state.settingRecord.pin) + "\n                        "), _c('br'), (_vm.$store.state.settingRecord.cin) ? _c('span', [_vm._v("CIN : " + _vm._s(_vm.$store.state.settingRecord.cin) + ",")]) : _vm._e(), _vm._v(" Mobile No - " + _vm._s(_vm.$store.state.settingRecord.phone) + ","), _c('br'), _vm._v(" Email ID - " + _vm._s(_vm.$store.state.settingRecord.email) + ", "), (_vm.$store.state.settingRecord.url) ? _c('span', [_vm._v("Website - " + _vm._s(_vm.$store.state.settingRecord.url))]) : _vm._e()]), _c('br')])])], 1), _vm._v(" "), (_vm.empInfo.employee) ? _c('td', {
    staticClass: "text-right",
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.empInfo.employee.code,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                          Show this if the rendering fails.\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center lh-1 mb-2"
  }, [_c('p', [_c('strong', [_vm._v("Payslip for the month of " + _vm._s(_vm.empInfo.remark))])])]), _vm._v(" "), _c('table', {
    staticClass: "mt-4 table table-bordered",
    attrs: {
      "width": "100%"
    }
  }, [(_vm.empInfo.employee) ? _c('thead', {
    staticClass: "bg-dark text-white"
  }, [_c('tr', [_c('td', [_c('strong', [_vm._v("EMP Code : ")]), _vm._v(" " + _vm._s(_vm.empInfo.employee.code))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("EMP Name :")]), _vm._v(" " + _vm._s(_vm.empInfo.employee.name))])]), _vm._v(" "), (_vm.empInfo.branch) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Branch Code : ")]), _vm._v(" " + _vm._s(_vm.empInfo.branch.branchCode))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Branch Name :")]), _vm._v(" " + _vm._s(_vm.empInfo.branch.name))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(" Designation :")]), _vm._v(" "), (_vm.empInfo.employee.agent_profile.designation) ? _c('span', [_vm._v(_vm._s(_vm.empInfo.employee.agent_profile.designation.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact No. :")]), _vm._v(" " + _vm._s(_vm.empInfo.employee.mobile))])]), _vm._v(" "), (_vm.empInfo.employee.agent_profile) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Bank :")]), _vm._v(" "), (_vm.empInfo.employee.agent_profile.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.empInfo.employee.agent_profile.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Ac No. :")]), _vm._v(" "), (_vm.empInfo.employee.agent_profile.accountNumber) ? _c('span', [_vm._v(" " + _vm._s(_vm.empInfo.employee.agent_profile.accountNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Transaction Date. :")]), _vm._v(" " + _vm._s(_vm.empInfo.transactionDate))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Mode of Pay :")]), _vm._v(" " + _vm._s(_vm.empInfo.payMode))])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('table', {
    staticClass: "mt-4 table table-bordered",
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Basic")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.basic))]), _vm._v(" "), _c('td', [_vm._v("PF")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.pfDeductions))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Fuel Allowance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.fuelAllowance))]), _vm._v(" "), _c('td', [_vm._v("Advance Deductions")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.advanceDeductions))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("HRA")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.houseRentAllowance) + " ")]), _vm._v(" "), _c('td', [_vm._v("Leave Deduction")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.leavesDeductions))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Commision")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.commission) + " ")]), _vm._v(" "), _c('td', [_vm._v("Other Deduction")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getOtherDeduction(_vm.empInfo.otherDeductions)))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Mobile Allowance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.mobileAllowance) + " ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Special Allowance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.empInfo.specialAllowance) + " ")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Other Allowance")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getOtherDeduction(_vm.empInfo.otherAllowance)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(1 * _vm.empInfo.basic + 1 * _vm.empInfo.fuelAllowance + 1 * _vm.empInfo.houseRentAllowance + 1 * _vm.empInfo.commission + 1 * _vm.empInfo.mobileAllowance + 1 * _vm.empInfo.specialAllowance + 1 * _vm.getOtherDeduction(_vm.empInfo.otherAllowance)))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s((1 * _vm.empInfo.pfDeductions) + (1 * _vm.empInfo.advanceDeductions) + (1 * _vm.empInfo.leavesDeductions) + (1 * _vm.getOtherDeduction(_vm.empInfo.otherDeductions))))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.empInfo.salary))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Net Payable : " + _vm._s(_vm.empInfo.salary))])]), _vm._v(" "), (_vm.empInfo.salary) ? _c('p', [_c('br'), _vm._v(" " + _vm._s(_vm.$store.state.settingRecord.companyName) + " Authorised Signatory")]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(6)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center lh-1 mb-2"
  }, [_c('p', [_c('strong', [_vm._v("Salary Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "bg-dark text-white"
  }, [_c('tr', [_c('td', [_c('strong', [_vm._v("Earnings")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Deductions")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_c('strong', [_vm._v("Earning (TE)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Total Deduction (TD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "scope": "row"
    }
  }, [_c('strong', [_vm._v("Total Salary (TE-TD)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f148479!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/SalarySlip.vue
// module id = 844
// module chunks = 0